"use strict";

import React from 'react';

function SaveCancelButtons({visible=false,
                         cancelText='Cancel',
                         cancelClassName='',
                         saveText='Save',
                         saveContent='',
                         saveClassName='',
                         saveButtonType='button',
                         wrapperStyle={},
                         onCancelClick=()=>{},
                         onSaveClick=()=>{},
                         loading=false}) {
    const disabled = !!loading || !visible;
    const defaultWrapperStyle = {padding: '.5rem 0',};
    return (
        <div style={{...defaultWrapperStyle, ...wrapperStyle}}>
            <a href="#"
               title={cancelText}
               className={`btn__secondary--outline btn--small ${cancelClassName} ${disabled ? 'btn--disabled' : ''}`}
               style={{marginRight: '1rem'}}
               onClick={ visible ? onCancelClick: (e)=>{e.preventDefault();} }>
                {cancelText}
            </a>
            <button type={saveButtonType}
               title={saveText}
               className={`btn__primary btn--small ${saveClassName} ${disabled ? 'btn--disabled' : ''}`}
               disabled={disabled}
               onClick={ visible ? onSaveClick : (e)=>{e.preventDefault();} }>
                {saveText}{saveContent}
            </button>
        </div>
    );
}

export default SaveCancelButtons;
